import {combineReducers} from "redux";

import staffManagementViewModel from "./staffManagementViewModel";
import roleManageViewModel from "./roleManageViewModel";
import nursingUnitSettingViewModel from "./nursingunitsetting/nursingUnitSettingViewModel";
import nursingFieldSettingViewModel from "./nursingFieldSettingViewModel";
import approvalFlowViewModel from "./approvalFlowViewModel";
import bigUnitSettingViewModel from "./bigUnitSettingViewModel";
import employeeLoanSettingViewModel from "./employeeloansetting/employeeLoanSettingViewModel";
import employeeLoanApplyEditViewModel from "./employeeloansetting/employeeLoanApplyEditViewModel";
import reviewFormEditViewModel from "./employeeloansetting/reviewFormEditViewModel";
import nursingUnitSettingEditViewModel from "./nursingunitsetting/nursingUnitSettingEditViewModel";
import versionUpgradeViewModel from "./versionUpgradeViewModel";
import staffActivateViewModel from "./staffActivateViewModel";
import swjwSettingViewModel from "./swjwsetting/index";
import swjwRoleManagementViewModel from "./swjwRoleManagementViewModel";

const rootViewModel = combineReducers({
    staffManagementViewModel,
    roleManageViewModel,
    nursingUnitSettingViewModel,
    nursingUnitSettingEditViewModel,
    nursingFieldSettingViewModel,
    approvalFlowViewModel,
    bigUnitSettingViewModel,
    employeeLoanSettingViewModel,
    employeeLoanApplyEditViewModel,
    reviewFormEditViewModel,
    versionUpgradeViewModel,
    staffActivateViewModel,
    swjwSettingViewModel,
    swjwRoleManagementViewModel,
});

export default rootViewModel;
